import { ToastContainer } from 'react-toastify';

/** App-wide toast host — Credora-styled via credoraToast helpers */
export function CredoraToastContainer() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={4}
      className="credora-toast-container"
      toastClassName="credora-toast-host"
      bodyClassName="credora-toast-body"
      progressClassName="credora-toast-progress"
      icon={false}
    />
  );
}
